import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import io from "socket.io-client";
import "../styles/home.css";

class Home extends Component {

  constructor(props) {

    super(props);

    this.socket = null;

    this.onlineListener = null;

    this.state = {
      user: null,
      amount: 100,
      showSidebar: false,
      onlinePlayers: 0,
    };

  }

  async componentDidMount() {

    const token =
      localStorage.getItem("token");

    const userId =
      localStorage.getItem("userId");

    if (!token || !userId) {

      this.props.navigate("/", {
        replace: true
      });

      return;

    }

    this.socket = io(
      "https://api.hi-bigame.online",
      {
        transports: [
          "websocket",
          "polling"
        ],
      }
    );

    window.addEventListener(
      "beforeunload",
      this.handleUnload
    );

    this.onlineListener = (count) => {

      console.log(
        "ONLINE:",
        count
      );

      this.setState({
        onlinePlayers: count
      });

    };

    this.socket.on(
      "onlinePlayers",
      this.onlineListener
    );

    this.socket.on(
      "connect",
      () => {

        console.log(
          "HOME SOCKET CONNECTED"
        );

      }
    );

    this.socket.on(
      "connect_error",
      (err) => {

        console.log(
          "SOCKET ERROR",
          err
        );

      }
    );

    try {

      const res = await fetch(
        `https://api.hi-bigame.online/user/${userId}`,
        {
          headers: {
            "Content-Type":
              "application/json",
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      const freshUser =
        await res.json();

      if (
        !freshUser ||
        !freshUser.id
      ) {

        localStorage.clear();

        this.props.navigate(
          "/",
          {
            replace: true
          }
        );

        return;

      }

      this.setState({
        user: freshUser
      });

      this.socket.emit(
        "userOnline",
        freshUser.id
      );

    }

    catch (error) {

      console.log(error);

    }

  }

  handleUnload = () => {

    if (this.socket) {
      this.socket.disconnect();
    }

  };

  toggleSidebar = () => {

    this.setState({
      showSidebar:
        !this.state.showSidebar
    });

  };

  goToGame = () => {

    if (!this.state.user) {

      return this.props.navigate(
        "/"
      );

    }

    this.props.navigate(
      "/game",
      {
        state: {
          user: this.state.user,
          amount: this.state.amount
        }
      }
    );

  };

  logout = () => {

    if (this.socket) {
      this.socket.disconnect();
    }

    fetch(
      `https://api.hi-bigame.online/logout/${this.state.user.id}`,
      {
        headers: {
          "Content-Type":
            "application/json",
          Authorization:
            `Bearer ${localStorage.getItem("token")}`
        }
      }
    ).catch(() => { });

    setTimeout(() => {

      localStorage.removeItem(
        "user"
      );

      localStorage.removeItem(
        "token"
      );

      localStorage.removeItem(
        "userId"
      );

      this.props.navigate(
        "/",
        {
          replace: true
        }
      );

    }, 300);

  };

  componentWillUnmount() {

    if (this.socket) {

      this.socket.off(
        "onlinePlayers",
        this.onlineListener
      );

      this.socket.disconnect();

    }

    window.removeEventListener(
      "beforeunload",
      this.handleUnload
    );

  }

  render() {

    const { user } =
      this.state;

    if (!user) {

      return (
        <div
          style={{
            textAlign: "center",
            marginTop: "100px"
          }}
        >

          <h2>
            Loading...
          </h2>

        </div>
      );

    }

    return (

      <div>

        <div className="home-container">

          <div
            className="menu-icon"
            onClick={this.toggleSidebar}
          >
            ☰
          </div>

          <div
            className={`sidebar ${this.state.showSidebar
              ? "show"
              : ""
              }`}
          >

            <h2 className="logo">
              HI-BI
            </h2>

            <div className="profile-box">

              <img
                src="https://i.pravatar.cc/100"
                alt="profile"
                className="profile-img"
              />

              <p>
                👤 {user.username}
              </p>

            </div>

            <button
              onClick={() =>
                this.props.navigate(
                  "/profile",
                  {
                    state: { user }
                  }
                )
              }
            >
              Profile
            </button>

            <button
              onClick={() =>
                this.props.navigate(
                  "/history",
                  {
                    state: { user }
                  }
                )
              }
            >
              History
            </button>

            <button
              onClick={() =>
                this.props.navigate(
                  "/transactions",
                  {
                    state: { user }
                  }
                )
              }
            >
              Wallet
            </button>

            <button
              onClick={() =>
                this.props.navigate(
                  "/deposit",
                  {
                    state: { user }
                  }
                )
              }
            >
              Deposit
            </button>

            <button
              onClick={() =>
                this.props.navigate(
                  "/withdraw",
                  {
                    state: { user }
                  }
                )
              }
            >
              Withdraw
            </button>

            <button
              className="logout"
              onClick={this.logout}
            >
              Logout
            </button>

          </div>

          <div className="main-content">

            <h1 className="title">
              HI-BI GAME
            </h1>

            <h2>
              Welcome {user.username}
            </h2>

            <div className="card-container">

              <div className="card">

                <p>
                  💰 Balance coin
                </p>

                <h3>
                  {user.balance ?? 0}
                </h3>

              </div>

              <div className="card">

                <p>
                  🟢 Online Players
                </p>

                <h3>
                  {this.state.onlinePlayers}
                </h3>

              </div>

            </div>

            <h3>
              Select Entry Coins
            </h3>

            <div className="amount-box">

              {[20, 50, 100].map(
                (amt) => (

                  <button
                    key={amt}
                    className={
                      this.state.amount === amt
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      this.setState({
                        amount: amt
                      })
                    }
                  >
                    {amt}
                  </button>

                )
              )}

            </div>

            <button
              className="play-btn"
              onClick={this.goToGame}
            >
              ▶️ Play Game
            </button>

          </div>

        </div>

      </div>

    );

  }

}

export default withNavigation(Home);